var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"ration-skeleton"},_vm._l((_vm.props.count),function(i){return _c('div',{staticClass:"ration-skeleton__item"},[_c('div',{staticClass:"ration-skeleton__loader"}),_c('div',{staticClass:"ration-skeleton__loader"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }